
































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import QuickSnack from "@/components/QuickSnack.vue";
import MoneyField from "@/components/MoneyField.vue";
import NumberField from "@/components/NumberField.vue";
import VendingStatistics from "@/components/VendingStatistics.vue";
import VendingConfigCopy from "@/components/VendingConfigCopy.vue";
import VendingTerminalConfig from "@/components/VendingTerminalConfig.vue";
import Upload from "@/components/Upload.vue";
import AvatarRef from "@/components/AvatarRef.vue";
import * as util from "@/util";
import { addQueryToURL } from "@/util/url";
import { logError } from "@/util";
import { readDataURL } from "@/util/download";
import * as uiUtil from "@/uiUtil";
import { navigateToTerminal } from "@/uiUtil";
import {
  getVendingOptions,
  deleteVendingBranchData,
  getVendingBranchData,
  getVendingConfig,
  getVendingLanguageData,
  saveBranchVendorData,
  saveVendingBranchData,
  saveVendingBranchLanguageData
} from "@/domain/backend/vending";
import { Branch, Company, Terminal, VueRoot } from "@/domain";
import { sanitizeVendingConfig, newVendingConfig } from "@/domain/vending";
import { selectCompany } from "@/domain/store_util";

import { BranchLogoUrl, VendingConfig, VendingConfigOptions, VendingTerminalResponse } from "@/domain/api";

interface BaseNode {
  key: string;
  name: string;
  displayName: string;
}

interface BranchNode extends BaseNode {
  isTerminal: false;
  branch: Branch;
  children: TerminalNode[];
}

interface TerminalNode extends BaseNode {
  isTerminal: true;
  branch: Branch;
  data: Terminal;
}

interface PreviewImage {
  data: string;
  extension: string;
  changed: boolean;
}

@Component({
  components: {
    QuickSnack,
    MoneyField,
    NumberField,
    Upload,
    AvatarRef,
    VendingStatistics,
    VendingConfigCopy,
    VendingTerminalConfig
  }
})
export default class VendingConfigView extends Vue {
  // Filter variables
  isLoadingTerminal = false;

  // Branch Data
  branchData: BranchLogoUrl = { logoUrl: "", vendorLogoUrl: "" };
  branchDataLoading = false;

  // Language
  language: string | null = "ES";
  prevLenguage: string | null = null;
  langDialog = false;

  // Logo
  deleteLogoDialog = false;
  logoTypeToDelete: "logoUrl" | "vendorLogoUrl" | null = null;
  logoToUpload: PreviewImage | null = null;
  vendorLogoToUpload: PreviewImage | null = null;
  uploadingLogo = false;

  // Terminal tabs
  tab = 0;
  vendingData: VendingTerminalResponse | null = newVendingConfig(0, 0, "", "");

  // General data
  terminalSearch = "";
  openTreeArr: BranchNode[] = [];
  selectedTreeArr: (BranchNode | TerminalNode)[] = [];
  vendingOptions: VendingConfigOptions | null = null;

  async created() {
    this.vendingOptions = await getVendingOptions();
    if (this.$route.query && this.$route.query.companyID && this.$route.query.branchID) {
      await selectCompany(this.$store, this.$route.query.companyID);
      this.$nextTick(() => {
        const branchID = util.toNumber(this.$route.query.branchID);
        const branch = this.treeItems.find((b) => b.branch.id === branchID);
        if (!branch) {
          logError(`Branch '${branchID}' not found`);
          return;
        }
        if (!this.openTreeArr.includes(branch)) this.openTreeArr.push(branch);
        const code = this.$route.query.terminalID as string;
        const tcod = this.$route.query.tcod as string;
        this.$nextTick(() => {
          const terminal = branch.children.find(
            (t) => (!!code && t.data.code == code) || (!!tcod && t.data.tcod == tcod)
          );
          if (terminal) {
            this.selectedTreeArr = [terminal];
          }
        });
      });
    } else if (this.treeItems.length > 0) {
      this.selectedTreeArr = [this.treeItems[0]];
    }
  }

  get lang() {
    return this.$store.state.lang.data;
  }

  get areLogosChanged() {
    return (this.logoToUpload?.changed ?? false) || (this.vendorLogoToUpload?.changed ?? false);
  }

  get userCompaniesLoading(): boolean {
    return this.$store.state.userCompaniesLoading;
  }

  get userCompanies(): Company[] {
    return this.$store.state.userCompanies || [];
  }

  get languageOptions() {
    return this.vendingOptions?.languages ?? [];
  }

  get tcod() {
    return this.vendingData ? this.vendingData.TCOD : null;
  }

  get snackbar() {
    return this.$refs.snackbar as QuickSnack;
  }

  get companiesLoading(): boolean {
    return this.$store.state.userCompaniesLoading || this.$store.state.selectedCompanyLoading;
  }

  get currentCompany(): Company | null {
    return this.$store.state.selectedCompany;
  }

  get isMobile(): boolean {
    return (this.$root as VueRoot).isMobile;
  }

  get currentBranches(): Branch[] {
    return uiUtil.branchComboItems(this.currentCompany, this.$store.getters.userPermission).filter((b) => b.isVending);
  }

  get logoFile() {
    return this.$refs.logoFile as HTMLInputElement;
  }
  get vendorLogoFile() {
    return this.$refs.vendorLogoFile as HTMLInputElement;
  }

  get selTerminal(): Terminal | null {
    for (const n of this.selectedTreeArr) {
      if (n.isTerminal) return n.data;
    }
    return null;
  }

  get selBranch(): Branch | null {
    if (this.selectedTreeArr.length == 0) return null;
    return this.selectedTreeArr[0].branch;
  }

  get hasTerminal(): boolean {
    return !!this.selBranch && !!this.selTerminal;
  }

  get currentTerminals(): Terminal[] {
    if (!this.selBranch || !this.selBranch.terminals || this.selBranch.terminals.length === 0) {
      return [];
    }
    return this.selBranch.terminals;
  }

  get treeItems(): BranchNode[] {
    const vendingBranches = this.currentCompany?.branches?.filter((b) => b.isVending) ?? [];
    return vendingBranches.map((b) => ({
      isTerminal: false,
      key: `b-${b.id}`,
      name: `${b.name}-${b.customerID}`,
      displayName: b.name,
      branch: b,
      children: (b.terminals ?? []).map((t) => ({
        isTerminal: true,
        key: `t-${b.id}-${t.code}`,
        name: `${t.tcod}-${t.name}-${t.serialNumber}`,
        displayName: t.name,
        branch: b,
        data: t
      }))
    }));
  }

  onConfigCopied(data: { config: VendingConfig }) {
    if (!this.currentCompany || !this.selBranch || !this.selTerminal) return;
    this.vendingData = sanitizeVendingConfig(
      data.config,
      this.currentCompany.id,
      this.selBranch.id,
      this.selTerminal.code
    );
  }

  @Watch("selBranch")
  async onSelBranch() {
    if (!this.selBranch) {
      this.branchData = { logoUrl: "", vendorLogoUrl: "" };
      this.branchDataLoading = false;
    } else {
      this.branchDataLoading = true;
      try {
        const lang = await getVendingLanguageData(this.selBranch.id);
        this.language = lang.language;
        const burl = await getVendingBranchData(this.selBranch.id);
        if (burl.logoUrl) {
          burl.logoUrl = addQueryToURL(burl.logoUrl, "c", Math.random().toString());
        }
        if (burl.vendorLogoUrl) {
          burl.vendorLogoUrl = addQueryToURL(burl.vendorLogoUrl, "c", Math.random().toString());
        }
        this.branchData = burl;
      } catch (err) {
        this.snackbar.show(this.lang.errorLoadingLogo, "error");
        util.logError("Error loading logo", err);
      }
      this.branchDataLoading = false;
    }
    this.logoToUpload = { data: this.branchData.logoUrl as string, extension: "png", changed: false };
    this.vendorLogoToUpload = { data: this.branchData.vendorLogoUrl as string, extension: "png", changed: false };
  }

  @Watch("language")
  async onSelLanguage(current: string, previous: string) {
    if (this.langDialog && current) return;
    if (!this.branchDataLoading && this.selBranch?.id && this.language) {
      this.prevLenguage = previous;
      this.langDialog = true;
    }
  }

  closeChangeLang() {
    this.language = this.prevLenguage;
    setTimeout(() => {
      this.langDialog = false;
    }, 300);
  }

  async changeLang() {
    if (this.selBranch?.id && this.language) {
      const result = await saveVendingBranchLanguageData({
        branchID: this.selBranch?.id,
        language: this.language
      });
      if (result.saved) {
        this.snackbar.show(this.lang.successfulSave, "success");
      } else {
        this.snackbar.show(`Error: ${result.message}`, "error");
      }
    }
    this.langDialog = false;
  }

  @Watch("selTerminal")
  async onSelTerminal() {
    this.vendingData = null;
    this.isLoadingTerminal = true;
    try {
      if (!this.currentCompany || !this.selBranch || !this.selTerminal) {
        return;
      }
      const tcod = this.selTerminal.tcod;
      const data = await getVendingConfig(tcod);

      if (tcod !== this.selTerminal.tcod) {
        // Si el usuario selecciono otro terminal mientras se cargaba, ignoramos el resultado
        // Verificamos que el tcod corresponda al consultado por si el usuario cambio su selección
        return;
      }
      let newVendingData: VendingConfig | null;
      if (data.found && !!data.vendingConfig) {
        newVendingData = sanitizeVendingConfig(
          data.vendingConfig,
          this.currentCompany.id,
          this.selBranch.id,
          this.selTerminal.code
        );
      } else {
        newVendingData = newVendingConfig(
          this.currentCompany.id,
          this.selBranch.id,
          this.selTerminal.tcod,
          this.selTerminal.code
        );
      }
      this.vendingData = newVendingData;
    } catch (ex) {
      util.logError("Error loading terminal", { ex });
      this.snackbar.show("Error: " + (ex as Error).message, "error");
    }
    this.isLoadingTerminal = false;
  }

  openCompanyInfo() {
    if (!this.currentCompany) return;
    navigateToTerminal(this, "info", this.currentCompany, this.selBranch, this.selTerminal?.tcod);
  }

  openLogoFileInput() {
    this.logoFile.click();
  }

  openVendorLogoFileInput() {
    this.vendorLogoFile.click();
  }

  async onLogoFileChanged() {
    const image = await this.processImage(this.logoFile, "branch");
    if (image != null) {
      this.logoToUpload = image;
    }
  }

  async onVendorLogoFileChanged() {
    const image = await this.processImage(this.vendorLogoFile, "vendor");
    if (image != null) {
      this.vendorLogoToUpload = image;
    }
  }

  async processImage(fileInput: HTMLInputElement, logoType: "branch" | "vendor"): Promise<PreviewImage | null> {
    const files = fileInput.files;
    if (!files || files.length === 0) {
      util.log("No files to upload");
      return null;
    }
    try {
      const dataUrl = await readDataURL(files[0]);
      util.log(`Logo ${logoType} loaded`, { dataUrl });
      fileInput.value = "";
      return { data: dataUrl as string, extension: "png", changed: true };
    } catch (err) {
      util.logError("Error loading image", err);
      this.snackbar.show(this.lang.errorLoadingImage, "error");
      return null;
    }
  }

  showDeleteModal(logoType: "logoUrl" | "vendorLogoUrl") {
    this.logoTypeToDelete = logoType;
    this.deleteLogoDialog = true;
  }

  closeDeleteLogoDialog() {
    this.logoTypeToDelete = null;
    this.deleteLogoDialog = false;
  }

  async executeDeleteLogo() {
    this.deleteLogoDialog = false;
    if (!this.selBranch || !this.logoTypeToDelete) return;
    const data = {
      branchID: this.selBranch.id,
      action: "DELETE",
      [this.logoTypeToDelete]: true
    };
    const result = await deleteVendingBranchData(data);
    if (result.saved) {
      this.snackbar.show("Imagen Eliminada", "success");
      if (this.logoTypeToDelete == "logoUrl") {
        this.vendorLogoToUpload = null;
        this.vendorLogoFile.value = "";
      } else {
        this.logoToUpload = null;
        this.logoFile.value = "";
      }
      await this.onSelBranch();
    } else {
      this.snackbar.show("Error: " + result.message, "error");
    }
  }

  async uploadLogoImages() {
    if (!this.selBranch) return;
    try {
      this.uploadingLogo = true;
      const r1 = await this.uploadLogo(this.selBranch, this.logoToUpload, "branch");
      const r2 = await this.uploadLogo(this.selBranch, this.vendorLogoToUpload, "vendor");
      if (r1 || r2) {
        this.snackbar.show(this.lang.updatedImage, "success");
        await this.onSelBranch();
      }
      this.uploadingLogo = false;
    } catch (err) {
      util.logError("Error uploading image", err);
      this.snackbar.show(this.lang.errorUloadingImage, "error");
    }
  }

  async uploadLogo(branch: Branch, image: PreviewImage | null, type: "branch" | "vendor"): Promise<boolean> {
    if (!image || !image.changed) {
      util.log(`Image ${type} is the same, not uploading`);
      return false;
    }
    const payload = {
      branchID: branch.id,
      extension: image.extension,
      image: image.data
    };
    util.log(`Saving ${type} logo to cloud`);
    const result = await (type == "branch" ? saveVendingBranchData(payload) : saveBranchVendorData(payload));
    if (!result.saved) {
      this.snackbar.show(`${type.toUpperCase()} Image Error: ${result.message}`, "error");
    }
    return result.saved;
  }
}
